import {
  createContext,
  type FC,
  type ReactNode,
  useContext,
  useMemo,
} from 'react';

export interface ILineItemActionsContext {
  buyNowActionEnabled: boolean;
  designFeedbackActionEnabled: boolean;
  displayPosition?: number;
  editAndReorderActionEnabled: boolean;
  fulfillmentHistoryEnabledForLineItem: boolean;
  isGroupItem: boolean;
  isReorderable: boolean;
  reorderActionEnabled: boolean;
}

export const LineItemActionsContext =
  createContext<ILineItemActionsContext | null>(null);

export const LineItemActionsProvider: FC<
  ILineItemActionsContext & { children: ReactNode }
> = ({ children, ...props }) => {
  const contextValue = useMemo(() => ({ ...props }), [props]);

  return (
    <LineItemActionsContext.Provider value={contextValue}>
      {children}
    </LineItemActionsContext.Provider>
  );
};

export const useLineItemActions = (): ILineItemActionsContext => {
  const context = useContext(LineItemActionsContext);
  if (!context) {
    throw new Error(
      'useLineItemActions must be used within an LineItemActionsContextProvider'
    );
  }
  return context;
};
